<div
  class="navigation-wrapper"
  (mouseover)="exibirSetas(true)"
  (mouseout)="exibirSetas(false)"
>
  <div class="keen-slider keen-slider--vertical" #sliderRef>
    <div
      *ngFor="let item of lista"
      class="keen-slider__slide"
      [ngClass]="{ 'carousel--clickable': item.link }"
    >
      <a (click)="abrirLink(item.link)">
        <img class="img-carousel" [src]="item.caminhoImagem" />
      </a>
    </div>
  </div>
  <a class="setas hide" *ngIf="lista.length > 1">
    <svg
      class="arrow arrow--left"
      (click)="slider.prev()"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
      />
    </svg>
  </a>
  <a class="setas hide" *ngIf="lista.length > 1">
    <svg
      class="arrow arrow--right"
      (click)="slider.next()"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </svg>
  </a>
</div>
<div class="dots" *ngIf="lista.length > 0">
  <button
    (click)="slider.moveToIdx(i)"
    *ngFor="let slide of lista; let i = index"
    [ngClass]="'dot ' + (i === currentSlide ? 'active' : '')"
  ></button>
</div>
